import gql from 'graphql-tag'

const GET_REFRESH_TOKEN = () => {
  return gql`
    {
      refreshToken
    }
  `
}

export default GET_REFRESH_TOKEN
